
export const INTENT_TYPES = {
  MANUAL_TO_AUTOMATION: 'MANUAL_TO_AUTOMATION',
  MIGRATE_SCRIPTS:      'MIGRATE_SCRIPTS',
  JIRA_REQUIREMENTS:    'JIRA_REQUIREMENTS',
  SAMPLE_PROJECT:       'SAMPLE_PROJECT',
};


export const WIZARD_INTENT = {
  MANUAL_TESTS_TO_AUTOMATION: 1,
  MIGRATE_SCRIPTS:            2,
  JIRA_TESTS:                 3,
  SAMPLE_PROJECT:             4,
};


export const intentToApiValue = (intentType) => {
  const mapping = {
    [INTENT_TYPES.MANUAL_TO_AUTOMATION]: WIZARD_INTENT.MANUAL_TESTS_TO_AUTOMATION,
    [INTENT_TYPES.MIGRATE_SCRIPTS]:      WIZARD_INTENT.MIGRATE_SCRIPTS,
    [INTENT_TYPES.JIRA_REQUIREMENTS]:    WIZARD_INTENT.JIRA_TESTS,
    [INTENT_TYPES.SAMPLE_PROJECT]:       WIZARD_INTENT.SAMPLE_PROJECT,
  };
  return mapping[intentType];
};


export const ROLE_ENUM = {
  QA_LEAD:           4,
  SENIOR_QA_ENGINEER: 5,
  QA_ENGINEER:       6,
  DEVELOPER:         7,
  MANAGER:           8,
  OTHER:             9,
};

export const ROLE_OPTIONS = [
  { label: 'QA Lead',            value: ROLE_ENUM.QA_LEAD },
  { label: 'Senior QA Engineer', value: ROLE_ENUM.SENIOR_QA_ENGINEER },
  { label: 'QA Engineer',        value: ROLE_ENUM.QA_ENGINEER },
  { label: 'Developer',          value: ROLE_ENUM.DEVELOPER },
  { label: 'Manager',            value: ROLE_ENUM.MANAGER },
  { label: 'Other',              value: ROLE_ENUM.OTHER },
];


export const APPLICATION_TYPES = {
  API:         'api',
  WEB:         'web',
  MOBILE:      'mobile',
  IOT_HARDWARE: 'iot_hardware',
};


export const TEST_CREATION_MODES = {
  AI:           'AI',
  RECORDER:     'RECORDER',
  UI_DISCOVERY: 'UI_DISCOVERY',
};


export const IOT_INTERACTION_MODES = {
  PROTOCOL: 'PROTOCOL',
  PHYSICAL: 'PHYSICAL',
  HYBRID:   'HYBRID',
};


export const UI_MAP_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  BUILDING:    'BUILDING',
  READY:       'READY',
  FAILED:      'FAILED',
};


export const STEP_STATUS = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  COMPLETED:   'completed',
};


export const STEP_MODE = {
  CREATE: 'create',
  EDIT:   'edit',
};

export const WIZARD_STEPS = {
  INTENT_SELECTION: 1,
  AUTH: 'auth', // Special step, not counted in progress
  WORKSPACE_SETUP: 2,
  PROJECT_SETUP: 3,
  TEST_SOURCE: 4,
  TEST_CREATION_MODE: 5, // NEW: Choose how to create tests
  // Branching steps based on mode:
  // API path: 6A (AI Preview) → 7A (Generate) → 8 (Run) → 9 (Summary)
  // Recorder path: 6B (Agent) → 7B (Extension) → 8B (URL) → 9B (Recording) → 10B (Review) → 8 (Run) → 9 (Summary)
  // Discovery path: AI Preview → Discovery Setup → Crawl → Review → Run → Summary
  // Legacy discovery entry (mode=discovery): 6C Setup → 7C Crawl → 10C Review → Run → Summary
  AI_PREVIEW: '6A',
  INSTALL_AGENT: '6B',
  ENABLE_EXTENSION: '7B',
  RECORDING_SETUP: '8B',
  LIVE_RECORDING: '9B',
  REVIEW_RECORDING: '10B',
  DISCOVERY_SETUP: '6C',
  DISCOVERY_CRAWL: '7C',
  REVIEW_DISCOVERY: '10C',
  AUTOMATION_PREFS: 7, // Converged step - API generate preferences
  GENERATE_AUTOMATION: '7A',
  RUN_FIRST_TEST: 8,
  RESULTS_SUMMARY: 9
};

export const EMPTY_STEP_STATE = {
  status:          STEP_STATUS.NOT_STARTED,
  mode:            null,
  isEditing:       false,
  createdEntityId: null,
};

export const ONBOARDING_STORAGE_KEY = 'robitest_onboarding_draft_v1';